// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class DeleteLobbyAction implements flatbuffers.IUnpackableObject<DeleteLobbyActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):DeleteLobbyAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsDeleteLobbyAction(bb:flatbuffers.ByteBuffer, obj?:DeleteLobbyAction):DeleteLobbyAction {
  return (obj || new DeleteLobbyAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsDeleteLobbyAction(bb:flatbuffers.ByteBuffer, obj?:DeleteLobbyAction):DeleteLobbyAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new DeleteLobbyAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbyDeleteLobby;
}

static startDeleteLobbyAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbyDeleteLobby);
}

static endDeleteLobbyAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createDeleteLobbyAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  DeleteLobbyAction.startDeleteLobbyAction(builder);
  DeleteLobbyAction.addType(builder, type);
  return DeleteLobbyAction.endDeleteLobbyAction(builder);
}

unpack(): DeleteLobbyActionT {
  return new DeleteLobbyActionT(
    this.type()
  );
}


unpackTo(_o: DeleteLobbyActionT): void {
  _o.type = this.type();
}
}

export class DeleteLobbyActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbyDeleteLobby
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return DeleteLobbyAction.createDeleteLobbyAction(builder,
    this.type
  );
}
}
